import api from '@js/actions/api';

import {mapStore} from '@js/stores/mapStore';

import {RideTypeToRouteType} from '@js/components/modules/constants';

export const applyRideType = (rideType) => {
    mapStore.currentRideType = rideType;
    mapStore.currentRouteType = RideTypeToRouteType[rideType];

    mapStore.map?.setRouteType(mapStore.currentRouteType);
};

export const computeRideElevation = (elevationData, requestOptions = {}) => (
    api.post('/api/v1/rides/compute-elevation', {
        elevation: elevationData
    }, false, requestOptions)
);

export const computeRideDuration = (durationData, requestOptions = {}) => (
    api.post('/api/v1/rides/estimate-duration', {
        elevation: {
            paceProfile: mapStore.currentPaceProfile,
            ...durationData
        }
    }, false, requestOptions)
);
